import { $ } from '../../../src/Framework';
import { Component } from '../../../src/Component';
export class Menu extends Component {
    constructor(triggerElementName, menuElementName) {
        super('Menu', false);
        this.triggerElementName = triggerElementName;
        this.menuElementName = menuElementName;
    }
    async init() {
        await super.init();
        this.triggerElement = $(this.triggerElementName);
        this.menuElement = $(this.menuElementName);
        if (this.triggerElement.length == 0 || this.menuElement.length == 0) {
            this.warning('missing `triggerElement` or `menuElement`');
        }
        else {
            this.triggerElement.on('click', (event) => {
                event.preventDefault();
                this.triggerElement.toggleClass('active');
                this.menuElement.toggleClass('active');
            });
            this.success();
        }
    }
}
